"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _PanelContainer = _interopRequireDefault(require("./PanelContainer"));
var _customHooks = require("../custom-hooks");
var _ComponentBoundary = _interopRequireDefault(require("./ComponentBoundary"));
var _propHelpers = require("../prop-helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * A responsive footer that renders a series of LinkPanel items.
 */
const FooterSitemap = _ref => {
  let {
    src,
    tree
  } = _ref;
  const {
    data,
    status
  } = (0, _customHooks.useFetch)(src);
  const trunk = status === 'fetched' ? data : tree;
  return /*#__PURE__*/_react.default.createElement(_ComponentBoundary.default, {
    name: "FooterSitemap"
  }, /*#__PURE__*/_react.default.createElement(_PanelContainer.default, {
    trunk: trunk
  }));
};
FooterSitemap.propTypes = {
  /**
   * The URL to the footer content API.
   */
  src: _propHelpers.dataPropValidator,
  /**
   * A JSON object representing a response from the footer content API.
   */
  tree: _propHelpers.dataPropValidator
};
FooterSitemap.defaultProps = {
  tree: {}
};
var _default = exports.default = FooterSitemap;